<div class="changePass-main-container">
  <div class="changePass-container">
    <p class="changePass-container__desc">Define new password</p>
    <form
      [formGroup]="form"
      (ngSubmit)="changePass()"
      fxLayout="column"
      fxLayoutAlign="center"
    >
      <aran-input
        type="password"
        placeholder="Enter your old password"
        label="Old Password"
        formControlName="oldPassword"
        [obscure]="true"
        [errorMessages]="{
          required: errorMessages.required('Old Password'),
        }"
        (enterPressed)="onEnterPressed()"
      ></aran-input>

      <app-input-psw-criteria
        type="password"
        placeholder="Enter your new password"
        label="New Password"
        formControlName="newPassword"
        [obscure]="true"
        [criteriaList]="criteriaList"
        [errorMessages]="{
          required: errorMessages.required('New Password'),
          minlength: errorMessages.minlength(8),
          ascii: errorMessages.ascii,
          weak: errorMessages.weak
        }"
        (enterPressed)="onEnterPressed()"
      >
      </app-input-psw-criteria>

      <aran-input
        type="password"
        placeholder="Confirm your new password"
        label="Confirm Password"
        formControlName="confirmNewPassword"
        [obscure]="true"
        [errorMessages]="{
          required: errorMessages.required('Confirm Password'),
          passwordMismatch: errorMessages.notMatch
        }"
        (enterPressed)="onEnterPressed()"
      ></aran-input>

      <div class="mt-5">
        <aran-button
          class="w-full"
          [type]="'submit'"
          [name]="'Confirm'"
          [disabled]="!form.valid"
        ></aran-button>
      </div>
    </form>
  </div>
</div>
